'use strict';

angular.module('atex.dam').factory('DamGalleryConfiguration', ['DamService', '$q',
function(DamService, $q) {
  
  var configurations = [];
  
  return {
    loadConfigurations: function() {
      var deferred = $q.defer();
      if (configurations.length>0) {
        deferred.resolve(configurations);
      } else {
        DamService.getGalleryConfigurationsMap().then(function(response) {
          configurations.length = 0;
          Array.prototype.push.apply(configurations, response.data.aspects.contentData.data.configurations);
          deferred.resolve(configurations);
        }).then(null, function(error) {
          deferred.reject(error);
        });
      }
      return deferred.promise;
    },
    getConfigurations: function() {
      return configurations;   
    }
  };
}]);
